// Live word/character counting for the editor. Mirrors the server's
// implementation (apps/api/src/lib/words.ts) so counts shown while typing
// match the authoritative counts persisted on save.

export function countWords(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;
  const matches = trimmed.match(/\S+/g);
  return matches ? matches.length : 0;
}

export function countCharacters(text: string): number {
  return [...text.replace(/\s+/g, " ").trim()].length;
}
